import { PageNotFound_en, PageNotFound_es } from 'icons';
import { useAtomValue } from 'jotai';

import Constants from 'constants/index';

import { userPrefsAtom } from '@/atoms/userPrefs';

const PageNotFound404 = () => {
  const userPrefs = useAtomValue(userPrefsAtom);

  return (
    <main className="relative flex w-full flex-col items-center justify-center">
      {userPrefs.language === Constants.LANGUAGE.SPANISH_LANGUAGE_CODE ? (
        <PageNotFound_es className="mx-auto size-full max-w-[1030px]" />
      ) : (
        <PageNotFound_en className="mx-auto size-full max-w-[1030px]" />
      )}
    </main>
  );
};

export default PageNotFound404;
